


const ProfileCard = ()=>{


    return(
        <>
            <div className="ProfileCardNar">

            </div>
        </>
    )
}

export default ProfileCard